<template>
    <input 
        type="button" 
        :value="value"
        :class="thisClass"
        @click="clickHandler"
    >
</template>

<script>
/**
 * 共通ボタン
 * 
 * [プロパティ]
 * thisClass ... クラス名称を指定
 * value ... ボタン表示名称
 * disabled ... 使用不可なら'disabled'またはtrue
 * 
 * [イベント処理]
 * クリック時 ... 使用可能時にはthis.$emit('button-click', e)
 * 
 * [利用例]
 * <app-button
 *  value="ボタン表示名"
 *  @buttonClick='anyFunc'
 *  this-class="btn_jisyahyojunなどこのコンポネント内でクラス指定"
 * />
 */
export default {
    name:"AppButton",
    props: {
        /**
         * クラス名称のString
         */
        thisClass:{
            type:String,
            required:false
        },
        /**
         * ボタンに表示させる文字列
         */
        value:{
            type:String,
            required:true
        },
        /**
         * ボタンの表示可否(同時にクリック時の動作も管理している)
         */
        disabled:{
            type:[Boolean, String],
            required:false
        }
    },
    methods:{
        /**
         * クリック時に使用不可なら何もしない
         * 使用可能なら親コンポーネントで指定された動作を実行
         */
        clickHandler(e) {
            if (this.disabled) {
                return
            }
            this.$emit('button-click', e)
        }
    }
}
</script>

<style scoped>
input[type="button"]{
    display: inline-block;
    margin: 3px 3px 16px;
    padding: 4px 22px;
    font-size: 14px;
    font-weight: bolder;
    color: white;
    background-color:#178EAA;
    border:none;
    border-radius: 2px;
}

input[type="button"]:disabled{
    opacity: 0.5;
}
/* 共通 */
/*  センター揃え、右揃え、左揃え */
input[type="button"].align_center{
    display: block;
    margin: 5px auto;
}

/* キャンセル、戻るボタン */
input[type="button"].btn_cancel{
    color: white;
    background-color:#707070;
}

/* 大きいボタン */
input[type="button"].btn_big{
    padding: 8px 50px;
    font-size: 28px;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
    background:linear-gradient( #6DC7DD,#41B8D4);
    border-radius: 4px;
}
/* モーダルの読込でファイルを選択させるボタン */
input[type="button"].btn_file{
    padding: 8px 50px;
    font-size: 18px;
    color: #555;
    background-color: white;
    border: 2px #555 solid;
    border-radius: 5px;
}

</style>
